export interface IFieldStatistic {
  min: number | null
  max: number | null
  median: number | null
  Q1: number | null
  Q3: number | null
}

export type IFieldStatisticsResponse = Record<string, IFieldStatistic>

/** Normaliza o JSON de `GET .../get_field_statistics` (render_success direto). */
export function parseFieldStatisticsResponse(body: unknown): IFieldStatistic | null {
  if (!body || typeof body !== 'object') return null
  const o = body as Record<string, unknown>
  const num = (k: string): number | null => {
    const v = o[k]
    if (typeof v === 'number' && !Number.isNaN(v)) return v
    return null
  }
  return {
    min: num('min'),
    max: num('max'),
    median: num('median'),
    Q1: num('Q1') ?? num('q1'),
    Q3: num('Q3') ?? num('q3'),
  }
}
